/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { fetchBookingFormData, fetchSiteShiftTypes, fetchSiteWorkTypes, generateBookingLink } from './bookingLinksApi';
import { BookingLinksState, BookingShiftType, BookingSite, BookingWorkType } from './types';

const initialState: BookingLinksState = {
    sites: [],
    siteWorkTypes: [],
    siteShiftTypes: [],
    isLoadingSites: false,
    isLoadingWorkTypes: false,
    isLoadingShiftTypes: false,
    isGenerating: false,
    error: null,
};

export const bookingLinksSlice = createSlice({
    name: 'bookingLinks',
    initialState,
    reducers: {
        clearSiteWorkTypes: (state) => {
            state.siteWorkTypes = [];
        },
        clearSiteShiftTypes: (state) => {
            state.siteShiftTypes = [];
        },
    },
    extraReducers: (builder) => {
        builder.addCase(fetchBookingFormData.pending, (state) => {
            state.isLoadingSites = true;
        });
        builder.addCase(fetchBookingFormData.fulfilled, (state, action: PayloadAction<BookingSite[]>) => {
            state.isLoadingSites = false;
            state.sites = action.payload;
        });
        builder.addCase(fetchBookingFormData.rejected, (state, action) => {
            state.isLoadingSites = false;
            state.error = action.payload;
        });

        builder.addCase(fetchSiteWorkTypes.pending, (state) => {
            state.isLoadingWorkTypes = true;
        });
        builder.addCase(fetchSiteWorkTypes.fulfilled, (state, action: PayloadAction<BookingWorkType[]>) => {
            state.isLoadingWorkTypes = false;
            state.siteWorkTypes = action.payload;
        });
        builder.addCase(fetchSiteWorkTypes.rejected, (state, action) => {
            state.isLoadingWorkTypes = false;
            state.error = action.payload;
        });

        builder.addCase(fetchSiteShiftTypes.pending, (state) => {
            state.isLoadingShiftTypes = true;
        });
        builder.addCase(fetchSiteShiftTypes.fulfilled, (state, action: PayloadAction<BookingShiftType[]>) => {
            state.isLoadingShiftTypes = false;
            state.siteShiftTypes = action.payload;
        });
        builder.addCase(fetchSiteShiftTypes.rejected, (state, action) => {
            state.isLoadingShiftTypes = false;
            state.error = action.payload;
        });

        builder.addCase(generateBookingLink.pending, (state) => {
            state.isGenerating = true;
        });
        builder.addCase(generateBookingLink.fulfilled, (state) => {
            state.isGenerating = false;
        });
        builder.addCase(generateBookingLink.rejected, (state, action) => {
            state.isGenerating = false;
            state.error = action.payload;
        });
    },
});

export const { clearSiteWorkTypes, clearSiteShiftTypes } = bookingLinksSlice.actions;
export default bookingLinksSlice.reducer;
